import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { truncate } from '@shared/utils/strings';


@Pipe({ name: 'truncate' })
export class TruncatePipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {
    }

    transform(value: string, length: number, end: string = '...'): any {
        return truncate(value, length, end);
    }
}
